var View = require('views/base/view');
var BlocksView = require('views/block/block-collection-view');
var FeedbackService = require('services/feedback-service');
var AnimationService = require('services/animation-service');
var utils = require('lib/utils');

var MenuView = View.extend({
  autoRender: true,
  className: 'menu',
  template: require('./templates/menu'),
  listen:{
    'block:feedback mediator': 'renderFeedback'
  },
  listSelector: '.menu-items',
  animationDuration: 0,
  regions: {
    'blocks': '.blocks',
    feedback: '.feedback'
  },
  initialize: function(options){
    this.script = utils.tryRequire('menu/' + this.model.get('key') + '/' + this.model.get('key')) || {};
    if (this.script.initialized){
      this.script.initialized.call(this.script, this);
    }
    this.on('addedToDOM', _.bind(this.renderBlocks, this));
    View.prototype.initialize.apply(this, arguments);
  },
  renderBlocks: function(){
    this.delegate('click', '[data-close=true]', (e) => {
      e.preventDefault();
      this.trigger('close', this);
    });
    if (this.model.get('blocks')) {
      var blocksView = new BlocksView({
        collection: this.model.get('blocks'),
        region: 'blocks',
        script: this.script ? this.script.block : undefined,
        parent: this
      });
      this.subview('blocks', blocksView);
      if (this.script.loaded) {
        if (blocksView.isLoaded()){
          this.script.loaded.call(this.script, this);
        } else {
          this.listenTo(blocksView, 'block:state:loaded', () => this.script.loaded.call(this.script, this));
        }
      }
    } else {
      if (this.script.loaded) {
        this.script.loaded.call(this.script, this);
      }
    }
    AniJS.run();
    if(this.model.get('startAnimation')) {
      AnimationService.queueAnimationsRun();
    }
    this.model.set('state', 'playing');
    this.trigger('page:state:change', this);
  },
  renderFeedback: function(feedback, callbacks){
    FeedbackService.displayFeedback(this, feedback, callbacks);
  },
  dispose: function(){
    if (this.script.unloading){
      this.script.unloading.call(this.script, this, function(){});
    }
    View.prototype.dispose.apply(this, arguments);
  }
});

module.exports = MenuView;
